import _ from '@app/utils.js'

_.onElementReady('.page-node-type-about #about-numbers', () => {
  const DURATION = 3000
  const DELAY    = 300

  const easeOut = t => 1 - Math.pow(1 - t, 3)

  // Parsing numeri — gestisce:
  //   "3.500"  → 3500  (migliaia europee: punto seguito da esattamente 3 cifre)
  //   "1,5"    → 1.5   (decimale europeo con virgola)
  //   "2.3"    → 2.3   (decimale con punto, NON migliaia)
  //   "150"    → 150   (intero)
  const parseNum = str => {
    const s = str.trim()
    // migliaia europee: "3.500" o "1.234.567" — punto sempre seguito da esattamente 3 cifre
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) {
      const n = parseFloat(s.replace(/\./g, '').replace(',', '.'))
      return isNaN(n) ? null : n
    }
    // decimale europeo con virgola: "1,5"
    if (/^\d+,\d+$/.test(s)) {
      const n = parseFloat(s.replace(',', '.'))
      return isNaN(n) ? null : n
    }
    // intero o decimale con punto: "150", "2.3"
    const n = parseFloat(s)
    return isNaN(n) ? null : n
  }

  // Ricostruisce il formato originale per il display durante il counter
  const formatNum = (n, original) => {
    const s = original.trim()
    // migliaia europee: "3.500"
    if (/^\d{1,3}(\.\d{3})+$/.test(s)) {
      return Math.round(n).toLocaleString('it-IT')
    }
    // decimale europeo con virgola: "1,5"
    if (/^\d+,\d+$/.test(s)) {
      const decimals = s.split(',')[1].length
      return n.toFixed(decimals).replace('.', ',')
    }
    // decimale con punto: "2.3"
    if (/^\d+\.\d+$/.test(s)) {
      const decimals = s.split('.')[1].length
      return n.toFixed(decimals)
    }
    return Math.round(n).toString()
  }

  document.querySelectorAll('#about-numbers p strong').forEach(strong => {
    // Prende solo il nodo di testo diretto, escludendo <sub> e altri figli
    const textNode = Array.from(strong.childNodes)
      .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '')

    if (!textNode) return

    const originalText = textNode.textContent
    const target = parseNum(originalText)

    if (target === null) return

    // Azzera il valore visibile mantenendo la struttura (sub, ecc.)
    textNode.textContent = formatNum(0, originalText)

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return
        observer.unobserve(strong)

        setTimeout(() => {
          const startTime = performance.now()

          const tick = now => {
            const progress = Math.min((now - startTime) / DURATION, 1)
            textNode.textContent = formatNum(easeOut(progress) * target, originalText)
            if (progress < 1) requestAnimationFrame(tick)
          }

          requestAnimationFrame(tick)
        }, DELAY)
      })
    }, { threshold: 0.4 })

    observer.observe(strong)
  })
})
